<template>
    <div id="task-user-list" class="task-list container-md">
        <div class="row">
            <div class="d-flex align-items-center w-100 mt-2">
                <div
                    v-if="
                        _hasAccess('schedule.task.update') ||
                        _hasAccess('schedule.task.delete')
                    "
                    class="pl-4 py-2"
                >
                    <b
                        v-if="isSelected && _hasAccess('schedule.task.delete')"
                        @click="isSelected && bulkDelete()"
                        class="text-primary cursor-pointer"
                        >Delete Selected
                    </b>
                    <span
                        v-else-if="
                            _hasAccess('schedule.task.delete') && !isSelected
                        "
                        class="text-muted"
                        >Delete Selected</span
                    >

                    <span
                        v-if="
                            _hasAccess('schedule.task.update') &&
                            _hasAccess('schedule.task.delete')
                        "
                    >
                        |
                    </span>

                    <b
                        v-if="isSelected && _hasAccess('schedule.task.update')"
                        @click="isSelected && bulkComplete()"
                        class="text-primary cursor-pointer"
                    >
                        Complete Selected
                    </b>
                    <span
                        class="text-muted"
                        v-else-if="
                            !isSelected && _hasAccess('schedule.task.update')
                        "
                        >Complete Selected</span
                    >
                </div>
                <div
                    v-if="
                        isSelected &&
                        (_hasAccess('schedule.task.update') ||
                            _hasAccess('schedule.task.delete'))
                    "
                    class="text-muted text-center mb-0 p-2 mx-2"
                >
                    (
                    {{ selectLength }}
                    {{ selectLength == 1 ? "task" : "tasks" }} selected )
                </div>
            </div>

            <div class="table-holder table-responsive">
                <loader v-if="isLoading" class="w-100" />
                <b-table-simple v-else borderless hover class="list">
                    <thead>
                        <tr>
                            <th class="d-flex align-items-center">
                                <b-form-checkbox
                                    name="checkall"
                                    v-model="selectAll"
                                    @change="toggleAll"
                                    plain
                                    v-if="list.length != 0"
                                    :disabled="
                                        !_hasAccess('schedule.task.update') &&
                                        !_hasAccess('schedule.task.delete')
                                    "
                                />
                                Due:
                            </th>
                            <th>Status:</th>
                            <th class="text-nowrap">Patient (ID):</th>
                            <th class="text-nowrap">Assign To:</th>
                            <th class="task-td">Task:</th>
                            <th>
                                <i class="fas fa-chevron-right invisible"></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="list.length == 0">
                        <tr>
                            <td colspan="3"><i>No records available</i></td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr
                            v-for="(task, i) in list"
                            :key="i"
                            class="item cursor-pointer"
                            :class="{
                                'selected-row': task.id === currentSelectedId
                            }"
                            :data-task-id="task.id"
                            @click="setTask(task)"
                        >
                            <td
                                class="d-flex align-items-center"
                                :class="{
                                    'text-nowrap': isPastDue(task.date)
                                }"
                                @click.stop
                            >
                                <b-form-checkbox
                                    name="checktask"
                                    @change="checkboxChange"
                                    @click.stop
                                    v-model="task.selected"
                                    plain
                                    :disabled="
                                        !_hasAccess('schedule.task.update') &&
                                        !_hasAccess('schedule.task.delete')
                                    "
                                >
                                    <span
                                        v-if="task.date && isToday"
                                        :class="''"
                                        v-b-tooltip.hover.top
                                        :title="
                                            _carbonDateTimeDisplay(task.date)
                                        "
                                        >{{ getDateDisplay(task.date) }}</span
                                    >
                                    <span v-else-if="task.date">
                                        {{ _carbonDateTimeDisplay(task.date) }}
                                    </span>
                                </b-form-checkbox>
                            </td>
                            <td class="text-nowrap">
                                <div>
                                    <span
                                        v-if="task.status == 1"
                                        class="alert alert-info p-1"
                                        >Completed</span
                                    >
                                    <span
                                        v-else-if="task.status == 2"
                                        class="alert alert-warning p-1"
                                    >
                                        In Progress
                                    </span>
                                    <span
                                        v-else
                                        class="alert alert-success p-1"
                                    >
                                        Open
                                    </span>
                                </div>
                            </td>
                            <td v-if="task.patient" @click.stop>
                                <patient-name
                                    v-if="task.patient"
                                    :use-router="USE_PATIENT_MODULE_VUE"
                                    :patient="task.patient"
                                    :text="getPatientName(task.patient)"
                                />
                            </td>
                            <td v-else></td>
                            <b-td v-html="getAssignTo(task)"></b-td>
                            <td>
                                <i
                                    class="cus-exclamation"
                                    v-if="task.priority"
                                    v-b-tooltip.hover.top
                                    title="High Priority"
                                ></i>
                                <i
                                    class="fas fa-sync mr-1"
                                    v-if="
                                        task.task_profile &&
                                        task.task_profile.repeat_every > 1
                                    "
                                    v-b-tooltip.hover.top
                                    title="Recurring task"
                                ></i>
                                <span
                                    v-html="updateTextLink(task.content)"
                                ></span>
                            </td>
                            <td class="position-relative">
                                <i class="arrow fas fa-chevron-right"></i>
                            </td>
                        </tr>
                    </tbody>
                </b-table-simple>

                <div class="text-right w-100 p-3">
                    <b-pagination
                        v-if="meta && !isLoading"
                        v-show="meta.lastPage > 1"
                        class="vet-pagination mt-0 mb-0"
                        align="right"
                        v-model="meta.currentPage"
                        :total-rows="meta.total"
                        :per-page="meta.perPage"
                        prev-text="Prev"
                        next-text="Next"
                        :hide-goto-end-buttons="true"
                        @change="getList"
                    />
                </div>
            </div>
        </div>

        <modal-complete
            ref="modalBulkComplete"
            @reload="getList"
            :list="list"
        />
        <modal-delete
            ref="modalBulkDelete"
            @reload="clearRefresh"
            :list="list"
        />
    </div>
</template>
<script>
import { forEach, isEmpty } from "lodash";
import Tasks from "@/services/client-tasks";
import TextMixins from "@/mixins/text";
import { DateTime } from "luxon";

export default {
    components: {
        Loader: () => import("@/components/elements/loader-list"),
        PatientName: () => import("@/components/commons/patient-name"),
        ModalDelete: () => import("@/components/task-view/task-bulk-delete"),
        ModalComplete: () => import("@/components/task-view/task-bulk-complete")
    },
    mixins: [TextMixins],
    data() {
        return {
            list: [],
            selectAll: false,
            isLoading: true,
            meta: null,
            filterDate: null,
            isSelected: false,
            selectLength: 0,
            permissions: null
        };
    },
    computed: {
        viewTask() {
            return this.$store.getters["task/selected"];
        },
        selectedDate() {
            return this.$store.getters["task/selectedDate"];
        },
        searchText() {
            return this.$store.getters["task/searchText"];
        },
        status() {
            let status = this.$route.query.status;

            return status ? status : null;
        },
        taskStatus() {
            return this.$route.query.task_status;
        },
        isToday() {
            let theDate = this.$store.getters["task/selectedDate"];
            let today = this._now().toFormat(this._dateFormat);

            if (theDate) {
                return theDate == today;
            }

            return true;
        },
        currentSelectedId() {
            return this.viewTask?.id;
        }
    },
    sockets: {
        "v-broadcast"(payload) {
            if (payload.action === "refresh-task-list") {
                this.applyChangesTaskUpdated({
                    record: payload.record
                });
            } else if (payload.action === "task-updated") {
                /**
                 * payload?.notify_user_ids?.includes(this.$root.currentActor.id)
                 *
                 * originally we filtered by related users only (notify_user_ids).
                 * however when editing a Task, we can un-assign any assignee.
                 * in that case, the removed assignee will not receive the changes if we only filter by related users.
                 * so ended up remove the filter so that everyone in the same instance/clinic.
                 */
                setTimeout(() => {
                    Tasks.getTask(payload.task_id).then(res => {
                        this.applyChangesTaskUpdated({
                            record: res?.resource?.data
                            // notifyUsers: payload?.notify_user_ids ?? []
                        });
                    });
                }, 300);
            }
        }
    },
    watch: {
        selectedDate(val) {
            if (this.filterDate != val) {
                this.filterDate = val
                    ? val
                    : this._now().toFormat(this._dateFormat);
                this.getList(1);
                this.clearSelected();
            }
        },
        searchText() {
            this.getList(1);
            this.clearSelected();
        },
        status() {
            this.getList(1);
            this.clearSelected();
        },
        taskStatus() {
            this.getList(1);
            this.clearSelected();
        }
    },
    mounted() {
        if (this.$route.query?.due_date) {
            this.filterDate = this.$route.query.due_date;
            this.$store.commit("task/setDate", this.$route.query.due_date);
        } else {
            this.filterDate = this._now().toFormat(this._dateFormat);
        }
        this.init();

        this.$root.$on("task-list:refresh", this.getList);
    },
    beforeDestroy: function () {
        this.$root.$off("task-list:refresh", this.getList);
    },
    methods: {
        checkboxChange() {
            this.$nextTick(() => {
                let listSelected = _.filter(this.list, "selected");
                this.selectLength = listSelected.length;
                this.isSelected = listSelected.length > 0;
            });
        },
        refresh(date) {
            this.filterDate = date;
            this.getList(1);
        },
        clearRefresh() {
            this.clearSelected();
            this.getList();
        },
        init() {
            this._getSetting().then(() => {
                this.getList(1);
            });
        },
        clearSelected() {
            this.$store.commit("task/unSetSelectedTask");
        },
        getList(page) {
            this.isLoading = true;
            this.list = [];
            this.isSelected = false;
            this.selectAll = false;

            var params = {
                page: page ? page : 1,
                module: "schedule",
                status: this.status,
                per_page: 20,
                id: "tasks",
                due_date: this.isToday
                    ? null
                    : this.filterDate
                    ? this.filterDate
                    : "",
                query: this.searchText,
                source: "view"
            };

            if (isEmpty(this.status)) {
                params.task_status = this.taskStatus ? this.taskStatus : 0;
            }

            this._taskCheck();

            Tasks.getScheduleTasks(params)
                .then(response => {
                    this.isLoading = false;
                    if (response.message.code == 200) {
                        this.list = response.resource.data;
                        this.permissions = response.permissions;
                        this.meta = response.resource.meta;
                        this.autoSelectTask(this.$route.query?.id);
                    } else {
                        this.showListError();
                    }
                })
                .catch(error => {
                    this.isLoading = false;
                    this.showListError();
                    console.error(error);
                });
        },
        autoSelectTask(focusId) {
            if (!focusId) {
                return;
            }

            let index = this.list.findIndex(rec => rec.id === focusId);
            if (this.list[index]) {
                this.setTask(this.list[index]);
            }

            let newQuery = { ...this.$route.query };
            delete newQuery.id;

            this.$router.replace({
                path: this.$route.path,
                query: newQuery
            });
        },
        bulkDelete() {
            this.$refs.modalBulkDelete.open();
        },
        bulkComplete() {
            this.$refs.modalBulkComplete.open();
        },
        getDateDisplay(date) {
            let theDate = this._fromDateCarbon(date).setZone(this._timeZone);

            if (this.isPastDue(date)) {
                //show XX minutes/hours/day ago
                let pastDue = this._now().diff(theDate, [
                    "months",
                    "weeks",
                    "days",
                    "hours",
                    "minutes"
                ]);

                if (pastDue.months > 0) {
                    return this.setText(pastDue.months, "month", "months");
                } else if (pastDue.weeks > 0) {
                    return this.setText(pastDue.weeks, "week", "weeks");
                } else if (pastDue.days > 0) {
                    return this.setText(pastDue.days, "day", "days");
                } else if (pastDue.hours > 0) {
                    return this.setText(pastDue.hours, "hour", "hours");
                } else if (Math.trunc(pastDue.minutes) > 0) {
                    return this.setText(
                        Math.trunc(pastDue.minutes),
                        "minute",
                        "minutes"
                    );
                } else {
                    return theDate.toFormat("hh:mm a");
                }
            } else {
                if (theDate.hasSame(this._now(), "day")) {
                    return theDate.toFormat("hh:mm a");
                } else {
                    return this._carbonDateTimeDisplay(date);
                }
            }
        },
        setText(value, singular, plural) {
            if (value > 1) {
                return value + " " + plural + " ago";
            } else {
                return value + " " + singular + " ago";
            }
        },
        isPastDue(date) {
            let compareDate = this._fromDateCarbon(date).setZone(
                this._timeZone
            );
            if (compareDate) {
                if (compareDate < this._now()) {
                    return true;
                }
            }

            return false;
        },
        showListError() {
            this._message("Error : Unable to get task list", "danger");
        },
        async toggleAll(checked) {
            forEach(this.list, function (task) {
                task.selected = checked;
            });

            this.checkboxChange();
        },
        setTask(task) {
            this.$store.dispatch("task/getTaskDetails", task.id).then(() => {});
        },
        getAssignTo(task) {
            var staffs = "";
            var roles = "";

            if (task.assign_to_staffs.length) {
                task.assign_to_staffs.forEach(staff => {
                    staffs += staff.staffName + "<br/>";
                });
            }

            if (task.assign_to_roles.length) {
                task.assign_to_roles.forEach(role => {
                    roles += role.roleName + "<br/>";
                });
            }
            return staffs + roles;
        },
        getPatientName(patient) {
            let primaryOwner = "";

            if (
                patient.primary_owner &&
                patient.primary_owner[0] &&
                patient.primary_owner[0].lastname
            ) {
                primaryOwner = " " + patient.primary_owner[0].lastname;
            }
            return patient.name + primaryOwner + " (" + patient.index + ")";
        },
        applyChangesTaskUpdated({ record }) {
            const validateDateList = record => {
                const dateRecord = record?.date?.date;

                if (!dateRecord) {
                    return false;
                }

                const parsedDate = DateTime.fromFormat(
                    this.selectedDate,
                    this._dateFormat,
                    {
                        zone: this._timeZone
                    }
                );
                const startOfDay = parsedDate.startOf("day").toMillis();
                const endOfDay = parsedDate.endOf("day").toMillis();

                const recordDate = DateTime.fromSQL(record.date?.date, {
                    zone: record.date?.timezone?.toLowerCase() ?? "utc"
                });

                // today + past due
                if (this.isToday) {
                    if (recordDate <= endOfDay) {
                        return true;
                    }
                }
                // specific date
                else {
                    if (recordDate >= startOfDay && recordDate <= endOfDay) {
                        return true;
                    }
                }

                return false;
            };

            const isRelatedWithUser = (rec, userId) => {
                let assignedAsStaff = rec?.assign_to_staffs?.find(
                    s => s.staffId === userId
                );
                if (assignedAsStaff) {
                    return true;
                }

                let assignedAsRole = rec?.assign_to_roles?.find(
                    r => r.id === this.$root.currentActor.role_id
                );
                if (assignedAsRole) {
                    return true;
                }

                return false;
            };

            const updateDetails = record => {
                this.$store.dispatch("task/applyTaskDetails", {
                    record
                });
            };

            const updateRecordInList = (index, record) => {
                this.$set(this.list, index, record);
            };

            const removeFromList = record => {
                this.list = this.list.filter(
                    r => r.task_profile_id !== record.task_profile_id
                );
            };

            const addToList = record => {
                this.list.unshift(record);
            };

            let actorId = this.$root.currentActor.id;
            let isCurrentActorAssignee = isRelatedWithUser(record, actorId);
            let isCreatedByMe = record.create_by === actorId;

            let recordIndex = this.list.findIndex(
                rec => rec.task_profile_id === record.task_profile_id
            );

            let currentSelectedId = this.viewTask?.task_profile_id;
            let isRecordAlreadyInTheList = recordIndex > -1;
            let isSelected = currentSelectedId === record.task_profile_id;
            let page1 = this.meta.currentPage === 1;

            let page = {
                assignedToMe: this.$route.query.status === "3",
                createdByMe: this.$route.query.status === "4",
                allOpenInProgress: this.$route.query.task_status === "0",
                allCompleted: this.$route.query.task_status === "1"
            };

            let status = {
                open: record.task_profile?.status === 0,
                completed: record.task_profile?.status === 1,
                inProgress: record.task_profile?.status === 2,
                deleted: record?.task_profile?.isactive === false
            };

            // Explanation:
            // 1. If record is deleted, just remove it from the list if it exists and update if it's selected.
            // 2. For each "page" type, we either add, update, or remove based on status and whether it's already in the list or selected.
            // 3. Open and inProgress share the same behavior.

            if (status.deleted) {
                if (isRecordAlreadyInTheList) {
                    removeFromList(record);
                }
                if (isSelected) {
                    updateDetails(record);
                }
                return;
            }

            const isValidDate = validateDateList(record); // ensure the record is within the selected date

            if (page.assignedToMe) {
                if (!isValidDate) {
                    if (isRecordAlreadyInTheList) {
                        removeFromList(record);
                    }
                    if (isSelected) {
                        updateDetails(record);
                    }
                    return;
                }

                if (isCurrentActorAssignee) {
                    if (!isRecordAlreadyInTheList && page1 && isValidDate) {
                        addToList(record);
                        return;
                    }
                } else {
                    if (isRecordAlreadyInTheList) {
                        removeFromList(record);
                    }
                    if (isSelected) {
                        updateDetails(record);
                    }
                    return;
                }

                if (status.open || status.inProgress) {
                    if (isRecordAlreadyInTheList) {
                        updateRecordInList(recordIndex, record);
                    }
                    if (isSelected) {
                        updateDetails(record);
                    }
                    return;
                }

                if (status.completed) {
                    if (isRecordAlreadyInTheList) {
                        removeFromList(record);
                    }
                    if (isSelected) {
                        updateDetails(record);
                    }
                    return;
                }
            }

            if (page.createdByMe && isCreatedByMe) {
                if (!isValidDate) {
                    if (isRecordAlreadyInTheList) {
                        removeFromList(record);
                    }
                    if (isSelected) {
                        updateDetails(record);
                    }
                    return;
                }

                if (!isRecordAlreadyInTheList && page1 && isValidDate) {
                    addToList(record);
                    return;
                }

                if (status.open || status.inProgress || status.completed) {
                    if (isRecordAlreadyInTheList) {
                        updateRecordInList(recordIndex, record);
                    }
                    if (isSelected) {
                        updateDetails(record);
                    }
                    return;
                }
            }

            if (page.allOpenInProgress) {
                if (!isValidDate) {
                    if (isRecordAlreadyInTheList) {
                        removeFromList(record);
                    }
                    if (isSelected) {
                        updateDetails(record);
                    }
                    return;
                }

                if (status.completed) {
                    removeFromList(record);
                    if (isSelected) {
                        updateDetails(record);
                    }
                    return;
                }

                if (!isRecordAlreadyInTheList && page1 && isValidDate) {
                    addToList(record);
                    return;
                }

                if (status.open || status.inProgress) {
                    if (isRecordAlreadyInTheList) {
                        updateRecordInList(recordIndex, record);
                    }
                    if (isSelected) {
                        updateDetails(record);
                    }
                    return;
                }
            }

            if (page.allCompleted) {
                if (!isValidDate) {
                    if (isRecordAlreadyInTheList) {
                        removeFromList(record);
                    }
                    if (isSelected) {
                        updateDetails(record);
                    }
                    return;
                }

                if (!status.completed) {
                    removeFromList(record);
                    if (isSelected) {
                        updateDetails(record);
                    }
                    return;
                }

                if (
                    status.completed &&
                    !isRecordAlreadyInTheList &&
                    page1 &&
                    isValidDate
                ) {
                    addToList(record);
                    return;
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.table-holder {
    width: 100%;
    padding: 0 15px;
}

.font-normal {
    font-style: normal;
}

.task-list {
    background: white;
    padding: 0 15px;
}

.task-list table.list td,
.task-list table.list thead th {
    border-bottom: 0px !important;
}

.task-list table.list tr {
    border-bottom: 1px solid #dddddd;
}

.task-list .blank-box {
    width: 15px;
    height: calc(100% + 2px);
    height: -moz-calc(100% + 2px);
    height: -webkit-calc(100% + 2px);
    height: -o-calc(100% + 2px);
    position: absolute;
    top: -1px;
    right: -15px;
    background: #f7f7f7;
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
}

.task-list .temp-hide {
    display: none;
}

.task-list .task-td {
    min-width: 150px;
}

tr.item {
    &:hover {
        background: #f7f7f7;

        i.arrow {
            display: block;
        }
    }

    i.arrow {
        display: none;
    }
}

@media (min-width: 768px) {
    .table-holder {
        min-height: 460px;
        max-height: calc(100vh - 250px);
        overflow: scroll;
    }

    .text-md-nowrap {
        white-space: nowrap;
    }
}
</style>
